import { render, staticRenderFns } from "./financialInsuranceApplyFor.vue?vue&type=template&id=5df364d7&scoped=true"
import script from "./financialInsuranceApplyFor.vue?vue&type=script&lang=js"
export * from "./financialInsuranceApplyFor.vue?vue&type=script&lang=js"
import style0 from "./financialInsuranceApplyFor.vue?vue&type=style&index=0&id=5df364d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df364d7",
  null
  
)

export default component.exports